import { BoldIcon } from "components/common/Icons/BoldIcon";
import { useBold } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Bold/useBold";
import type { TextBox } from "store/features/memeGenerator/types";

interface BoldProps {
    textBox: TextBox;
}

export const Bold = ({ textBox }: BoldProps) => {
    const { isActive, handleClick } = useBold(textBox);
    return (
        <div
            className={`w-20 h-10 grid place-items-center ${
                isActive ? "bg-irGray-200 dark:bg-darkSurface-300" : "bg-transparent dark:bg-darkSurface-100 hover:bg-irGray-100"
            } rounded-lg border border-[#dfe0e2] dark:border-darkSurface-400`}
            onClick={handleClick}
        >
            <BoldIcon />
        </div>
    );
};
